export const actions = {
  set_state: 'coupon/set_state',
  get_coupon: 'coupon/get_coupon',
  create_coupon: 'coupon/create_coupon',
  check_coupon: 'coupon/check_coupon',
  download_coupon: 'coupon/download_coupon',
  get_one: 'coupon/get_one',
  delete_coupon: 'coupon/delete_coupon'
}
